import api from "../../../util/api";

const yearly = "/interface/v1/yearly-revenue/";
const monthly = "/interface/v1/monthly-revenue/";
const topYear = "/interface/v1/top-year/";
const topDay = "/interface/v1/top-day/";
const topMonth = "/interface/v1/top-month/";
const expiringProducts = "/interface/v1/top-month/";
const cardMonth = '/interface/v1/month-card/'
const cardYear = '/interface/v1/year-card/'

export default {
  async getYearly({ commit }) {
    try {
      const res = await api.get(yearly);
      const data = await res.json();
      commit("setYearly", { data: data.data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async getMonthly({ commit }) {
    try {
      const res = await api.get(monthly);
      const data = await res.json();
      commit("setMonthly", { data: data.data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async getCardMonth({ commit }) {
    try {
      const res = await api.get(cardMonth);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async getCardYear({ commit }) {
    try {
      const res = await api.get(cardYear);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async getTopYear({ commit }) {
    try {
      const res = await api.get(topYear);
      const data = await res.json();
      commit("setTopYear", { data: data.produtos });
      return data;
    } catch (err) {
      return err;
    }
  },
  async getTopDay({ commit }) {
    try {
      const res = await api.get(topDay);
      const data = await res.json();
      commit("setTopDay", { data: data.produtos });
      return data;
    } catch (err) {
      return err;
    }
  },
  async getTopMonth({ commit }) {
    try {
      const res = await api.get(topMonth);
      const data = await res.json();
      commit("setTopMonth", { data: data.produtos });
      return data;
    } catch (err) {
      return err;
    }
  },
  async getExpiringProducts({ commit }) {
    try {
      const res = await api.get(expiringProducts);
      const data = await res.json();
      commit("setTopMonth", { data: data.produtos });
      return data;
    } catch (err) {
      return err;
    }
  }
};
